import GroupFilter from "./GroupFilter";

/**
 * A group of native inputs styled as toggle buttons. Whether it behaves as multi- or single-select is
 * derived from the rendered input type (the `button-group.php` partial emits checkboxes for `mode="multi"`
 * and radios for `mode="single"`), so this reuses all of GroupFilter's value logic.
 */
export default class ButtonGroupFilter extends GroupFilter {
    get multiple() {
        return this.controls().first().attr("type") === "checkbox";
    }
}
